export const CheckEligibility = "c58eb478624ad65c3046927a63e7a5106cdf2f275da9a75312cbda56c947ac9f";